import { routerReducer } from '@ngrx/router-store';
import { Action, createReducer, on } from '@ngrx/store';
import { liveNursesReducers } from 'src/app/recruiting/candidates/live-nurses-new/store/reducers';
import { jobDetailsReducer } from 'src/app/recruiting/jobs/details/components/store/reducers/job-details.reducers';
import { RecruitingState } from './recruiting.state';
import { loadTeamInfo, loadTeamInfoFailure, loadTeamInfoSuccess } from './recruiting.actions';

const initialState: RecruitingState = {
    routerState: null,
    recruitingState: {
        teamInfo: null,
        loading: false
    },
    postedJobState: null,
    submittalJobsState: null,
    jobDetailsState: null,
    jobOptionsState: null,
    submittalNotesState: null,
    submittalState: null,
    jobPercentagesState: null
};

export function recruitingReducer(state: RecruitingState | undefined, action: Action) {
    return createReducer(
        initialState,

        on(loadTeamInfo, (state) => ({
            ...state,
            teamInfo: undefined
        })),

        on(loadTeamInfoSuccess, (state, action) => ({
            ...state,
            teamInfo: action.teamInfo
        })),

        on(loadTeamInfoFailure, (state, action) => ({
            ...state,
            teamInfo: undefined,
            error: JSON.stringify(action.error)
        }))
    )(state, action);
}
export function reducer(state: RecruitingState | undefined, action: Action) {
    return recruitingReducer(state, action);
}

export const RecruitingReducers = {
    routerState: routerReducer,
    //TODO: this doesn't work with AOT (live-nurses/store/reducers/index.ts). Find better way to merge in reducers or provide a separate Module to each menu-item
    // ...liveNursesReducers,

    //LiveNursesReducers
    postedJobState: liveNursesReducers.postedJobState,
    submittalNotesState: liveNursesReducers.submittalNotesState,
    jobOptionsState: liveNursesReducers.jobOptionsState,
    submittalJobsState: liveNursesReducers.submittalJobsState,
    submittalState: liveNursesReducers.submittalState,
    jobPercentagesState: liveNursesReducers.jobPercentagesState,

    jobDetailsState: jobDetailsReducer,
    recruitingState: recruitingReducer
};
